import routes from '@/routes/routes';
import { UserShowcaseSearchDto } from '@/types';
import { getProfilePhoto } from '@/utils/profilePhoto';
import Link from 'next/link';

const ShowcaseHighlight = ({ showcase }: { showcase: UserShowcaseSearchDto }) => {
  return (
    <div
      style={{
        background: `url(${
          showcase.profileBanner ?? '/images/checkBackground.png'
        }) no-repeat left/cover`,
      }}
      className="w-full min-h-[320px] xl:h-rest flex-1 relative"
    >
      <div className="absolute inset-0 px-3 md:px-8 lg:pr-11 lg:pl-20 py-14 flex flex-col justify-end bg-gradient-to-t from-black/70 to-transparent">
        <div className="flex flex-wrap flex-col xs:flex-row xs:items-center xs:justify-between gap-4">
          <div className="flex items-start gap-x-6">
            <div className="bg-white rounded-lg h-28 w-28 p-1.5">
              <img
                src={getProfilePhoto(showcase, 'original')}
                alt="user-image"
                className="w-full h-full rounded object-cover"
              />
            </div>

            <div className="flex flex-col items-start mt-0.5 gap-y-1 xs:gap-y-2.5">
              <span className="text-white text-base sm:text-xl font-bold capitalize">
                Showcase Highlight
              </span>
              <span className="text-white text-lg sm:text-2xl font-extrabold capitalize">
                {showcase.userName}
              </span>
              <span className="text-sm text-gray-d9">
                {showcase.itemsCount} items │ {showcase.followersCount} followers
              </span>
            </div>
          </div>

          <Link href={routes.showcase({ userId: showcase.id })}>
            <a className="btn-new btn-primary">View</a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ShowcaseHighlight;
